var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "1200" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [_c("v-spacer"), _c("v-spacer")]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: "Comparativo de simulação",
          subtitle: _vm.cliente ? _vm.cliente.name : ""
        }
      }),
      _c("SimuladorComparativo", {
        attrs: {
          "cliente-modal": _vm.cliente,
          "hash-simulacao-modal": _vm.hash_simulacao
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }